import * as React from "react";
import {SingleEntryControl} from "../Controls/SingleEntryControl";
import './Style.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {faPrint} from "@fortawesome/free-solid-svg-icons/faPrint";

export class SingleEntry extends React.Component<SingleEntryProps, SingleEntryState> {
    static defaultProps: Partial<SingleEntryProps> = {};

    public DivContainer:HTMLDivElement;
    public Iframe:HTMLIFrameElement;
    constructor(props: SingleEntryProps) {
        super(props);
        this.state = {};
        console.log(props.Form);
        console.log(props.Entries);
    }

    public render() {
        return (
            <div className={'rednao entry'} style={{padding:10}} ref={x=>this.DivContainer=x}>
                <h1>Form: {this.props.Form.FormName}</h1>

                <div className={'toolbar'} style={{margin:'10px 0 10px 0'}}>
                    <button style={{marginRight:5}} onClick={()=>this.props.ClearView()} className={'rnbtn rnbtn-primary'}><FontAwesomeIcon icon={faArrowLeft}/> Go Back</button>
                    <button  className={'rnbtn rnbtn-info'} onClick={()=>this.Print()}><FontAwesomeIcon icon={faPrint}/> Print</button>
                </div>
                <iframe style={{display:"none"}} id={'detailsPrint'}  ref={x=>this.Iframe=x}/>
                {this.props.Entries.map(x=>
                    <SingleEntryControl SelectedColumns={this.props.SelectedColumns} key={x._EntryId} Entry={x} ElementOptions={this.props.Form.ElementOptions}/>
                )}
            </div>
        )
    }

    private Print() {
        jQuery(this.Iframe).contents().find('html').html(
            `<style type="text/css">
                                    .toolbar{
                                        display: none;
                                        width:100%;
                                    }
                                    table{
                                        border:1px solid #dfdfdf;
                                        margin-bottom: 10px;
                                        width: 100%;
                                    }
                                    
                                    table table{
                                        border:none;
                                        width:auto;
                                    }
                                    
                                    .singleentry td:nth-of-type(odd)
                                    {
                                        padding-bottom: 20px;;
                                    } 
                                    
                              </style>`+ this.DivContainer.outerHTML);
        this.Iframe.contentWindow.print();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SingleEntryProps {
    Entries:any;
    Form:{FormId:string,FormName:string;ElementOptions:any[]};
    ClearView:()=>void;
    SelectedColumns:any[];
}

interface SingleEntryState {

}

//#endregion "My Region"